var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({staticClass:"carousel-slide",style:({ padding: ("0 " + _vm.padding + "px") })},'div',_vm.additionalProperties,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }